import * as Yup from 'yup';
import valid from 'card-validator';
import {SECURITY_CODE} from "../creditCard/CreditCardFields";
import {creditCardMessages} from "../creditCard/creditCardMessages";

export const getStoredPaymentValidationSchema = (formatMessage) => {
    return Yup.object({
        [SECURITY_CODE]: Yup.string()
            .required(formatMessage(creditCardMessages.CvvRequired))
            .test(
                'cvvIsValid',
                formatMessage(creditCardMessages.invalidCvv),
                
                function (cvv) {
                    let cvvSize = 3;
                    if (this.parent.cardType === 'americanexpress') {
                        cvvSize = 4;
                    }
                    return valid.cvv(cvv, cvvSize).isValid;
                }
            )
    }).shape();
};
